import { render, staticRenderFns } from "./BankReturn.vue?vue&type=template&id=3551c2a3"
import script from "./BankReturn.vue?vue&type=script&lang=js"
export * from "./BankReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports